type Props = {
	className?: string
}

export const CloseIcon = ({ className }: Props) => {
	return (
		<svg
			className={className}
			data-testid="closeIcon"
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M1.14492 14.8574L14.8574 1.14453"
				stroke="black"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M1.14492 1.1446L14.8574 14.8574"
				stroke="black"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	)
}
